import React, { useEffect, useRef } from "react";
import "./igsection.css";
import IgImg1 from "../../Media/Photos Gallery/club1.JPG";
import IgImg2 from "../../Media/Photos Gallery/club6.JPG";
import IgImg3 from "../../Media/Photos Gallery/gal2.png";
import IgImg4 from "../../Media/Photos Gallery/gal5.png";
import IgImg5 from "../../Media/Photos Gallery/gal7.png";
import IgImg6 from "../../Media/Photos Gallery/gal14.png";
import IgImg7 from "../../Media/Photos Gallery/gal19.png";
import IgImg8 from "../../Media/Photos Gallery/gal28.png";
import IgImg9 from "../../Media/Photos Gallery/wedding2.png";
import IgImg10 from "../../Media/Photos Gallery/wedding5.png";
import IgImg11 from "../../Media/Photos Gallery/wedding4.png";

const images = [IgImg1, IgImg11, IgImg2,IgImg10, IgImg3, IgImg4, IgImg9, IgImg5, IgImg6, IgImg7, IgImg8];

export default function InstagramSlider() {
  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;
    let scrollAmount = 0;

    const interval = setInterval(() => {
      if (slider) {
        slider.scrollBy({ left: 300, behavior: "smooth" });
        scrollAmount += 300;
        if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
          scrollAmount = 0;
          slider.scrollTo({ left: 0, behavior: "smooth" });
        }
      }
    }, 10000); 

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="instagram-container">
      <div className="instagram-header">
        <h2>Follow us on Instagram</h2>
        <a href="https://www.instagram.com/zak_arryy/">
          <button>FOLLOW US</button>
        </a>
      </div>
      <div className="image-slider" ref={sliderRef}>
        {images.map((src, idx) => (
          <img key={idx} src={src} alt={`insta-${idx}`} loading="lazy" decoding="async" />
        ))}
      </div>
    </div>
  );
}
